import Vue from 'vue'
import App from './App.vue'


// import VScrollLock from 'v-scroll-lock'
// Vue.use(VScrollLock)

import VModal from 'vue-js-modal';
Vue.use(VModal, { dynamic: true })

import VueTouch from 'vue-touch';
VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2
})
Vue.use(VueTouch);

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
